export default {
    login: {
        title: '五福临门',
        tip: '帐号密码登入',
        username: '請輸入用戶名',
        userpwd: '請輸入密碼',
        btn: '登入',
        bottom: '© 2020 T.G.K',
    },
    titles: {
        home: '首頁配置',
        ad: '廣告管理',
        theme: '主题列表',
        compare: '比较标签',
        hots: '热话列表',
        tags: '分类管理',
        news: '新闻列表',
        video: '視頻列表',
        user: '用户列表',
        usernews: '用户文章',
        feedback: '反馈列表',
        report: '举报列表',
        user: '帐户管理',
        source:"來源清單",
        
    },
    btns: {
        add: '添加',
        edit: '編輯',
        del: '删除',
        back: '返回',
    },

}